export enum ActSubsidyFilterKey {
  OrgTypes = 'orgTypesFilter',
  Org = 'orgFilter',
  SchoolYear = 'schoolYearFilter',
  Month = 'monthFilter',
  ClassType = 'classTypeFilter',
  SubsidiesType = 'subsidiesTypeFilter',
  DayCaresList = 'dayCaresListFilter',
  ClassesList = 'classesListFilter',
  StudentList = 'studentListFilter',
  Allowances = 'allowancesFilter',
}
